// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isDefined = (value: any): boolean => ![null, undefined].includes(value);

export default isDefined;
